import $ from 'jquery';
import Push from 'push.js';
import connectFilterNotifications from 'legacy/javascripts/notification.js';

$(function () {
  var filterNotifications = connectFilterNotifications;

  var notificationData = $('#js-alert-filer-data').data();

  var skipPolling = function () {
    return filterNotifications.notified || !filterNotifications.isOn();
  };

  filterNotifications.notified = false;
  filterNotifications.checkUpdates = function () {
    if (skipPolling()) {
      return;
    }
    var filters = filterNotifications.getFilterParams();
    $.ajax({
      type: 'post',
      url: notificationData.requestUrl,
      data: filters,
      dataType: 'json',
      success: function (response) {
        var mostRecent = filterNotifications.getMostRecent();
        var newMostRecent = response.solicitations[0].responded_at;

        if (mostRecent && newMostRecent && newMostRecent !== mostRecent) {
          filterNotifications.setMostRecent(newMostRecent);
          filterNotifications.sendAlert();
          filterNotifications.notified = true;
        }
      },
    });
  };

  if (!filterNotifications.isOn()) {
    return;
  }

  var fiveMins = 1000 * 60 * 5;
  window.setInterval(filterNotifications.checkUpdates, fiveMins);

  $(window).on('unload', Push.clear);
});
